export default {"src":"/pro/_next/static/media/xmr.f75f7d6f.svg","height":3756,"width":3756,"blurWidth":0,"blurHeight":0};